
import { email, required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import { getBaseUrlByBrand, PROJECT_BRANDS } from '@/modules/brand/domain/brand';

import { AUTH_LOGIN_MAGIC_LINK_SENT } from '../helpers/auth-component-names';

export default {
  name: 'Login',
  validations: {
    email: {
      email,
      required,
    },
  },
  components: {
    EmailInput: () => import('@/components/core/email-input/email-input.vue'),
  },
  data() {
    return {
      invalidEmail: false,
      isLoading: false,
      isEmailNotExist: null,
      email: '',
    };
  },
  computed: {
    homeUrl() {
      return getBaseUrlByBrand(this.$getBrand());
    },
    subtitle() {
      const textByBrandMap = {
        [PROJECT_BRANDS.reverse]: this.$t('auth.login.textSite'),
        [PROJECT_BRANDS.muscleCharge]: this.$t('auth.login.textSiteMuscleCharge'),
      };

      return textByBrandMap[this.$getBrand()] || this.$t('auth.login.textSite');
    },
    emailNotExistsText() {
      const textByBrandMap = {
        [PROJECT_BRANDS.reverse]: this.$t('auth.login.emailNotExists'),
        [PROJECT_BRANDS.muscleCharge]: this.$t('auth.login.emailNotExistsMuscleCharge'),
      };

      return textByBrandMap[this.$getBrand()] || this.$t('auth.login.emailNotExists');
    },
  },
  mounted() {
    this.$store.dispatch('auth/resetAuthData');
  },
  methods: {
    ...mapActions('auth', ['checkIfUserExistAction', 'setUserLoginEmailAction', 'setAuthComponentName', 'loginAction']),
    emailHandler($event) {
      this.email = $event;
    },
    submitFormHandler() {
      this.isLoading = true;
      this.setUserLoginEmailAction(this.email);
      this.checkIfUserExistAction(this.email).then(({ exists }) => {
        if (!exists) {
          this.isEmailNotExist = true;
          this.isLoading = false;
        } else {
          this.loginAction({
            email: this.email,
            redirectUrl: this.$route.query.redirect_url,
            redirectPath: this.$route.query.redirect_path,
          }).then(() => {
            this.setAuthComponentName(AUTH_LOGIN_MAGIC_LINK_SENT);
            this.isLoading = false;
          });
        }
      });
    },
    logout() {
      window.location.href = this.$getUrl('home');
    },
  },
};
